import { Modal } from "antd";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { common } from "../../services";
import "./style.scss";
import TopicItem from "../topicItem";

const PopupPromotion = (props: any, ref: any) => {
  const [visible, setVisible] = useState(false);
  const [banner, setBanner] = useState<any>([]);

  useImperativeHandle(ref, () => ({
    handleVisibleModal,
  }));

  const handleVisibleModal = (bool: boolean, id: string = "") => {
    if (bool) {
      common.getBanner("HOME", { id }, (data: any, err: any) => {
        if (data && data.length && data[0].banners.length) {
          setBanner(data[0].banners);
          setVisible(bool);
        }
      });
    } else {
      setVisible(bool);
    }
  };

  return (
    <Modal
      title={banner.length ? banner[0].title : ""}
      visible={visible}
      onOk={() => handleVisibleModal(false)}
      width="90%"
      onCancel={() => handleVisibleModal(false)}
      footer={null}
      className="popup-promotion">
      <React.Fragment>
        {banner.length ? <TopicItem banner={banner[0]} /> : null}
      </React.Fragment>
    </Modal>
  );
};

export default forwardRef(PopupPromotion);
